import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const ExamInsightsLazy = React.lazy(
	() => import(/* webpackChunkName : 'ExamInsights' */ './components')
);

export default (store) => [
	{
		path: 'exams-insights',
		element: <AsyncLoading component={<ExamInsightsLazy />} />,
	},
];
